export default __webpack_public_path__ + "static/char-v-59-d70f4bbad8fd4536052e8562498985a4.webp";